import { render, staticRenderFns } from "./ProLegalPage.vue?vue&type=template&id=0145d35c"
import script from "./ProLegalPage.vue?vue&type=script&lang=js"
export * from "./ProLegalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports